import { Reducer } from 'redux'
import { FinancialInstitution } from '~/types'
import { BLOCKCHAIN_ADDRESS_ACTIONS } from './const'
import { ActionTypes, BlockchainAddress } from './types'

export type StateFlippers = {
  isWhitelistingImprovementEnabled: boolean
}

export type State = StateFlippers & {
  blockchainAddressList: BlockchainAddress[]
  isBlockchainAddressListInitiated: boolean
  fiList: FinancialInstitution[]
  addressQuota: number
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const initialState: any = {}

export const blockchainAddresses: Reducer<State, ActionTypes> = (state = initialState, action) => {
  switch (action.type) {
    case BLOCKCHAIN_ADDRESS_ACTIONS.SET_FLIPPERS: {
      const flippers: Partial<StateFlippers> = {}

      if (state && action.flippers.size > 0) {
        action.flippers.forEach((value, key) => {
          flippers[key] = value
        })
      }

      return {
        ...state,
        ...flippers,
      }
    }

    default:
      return state
  }
}
